module.exports = __webpack_public_path__ + "static/img/图片 1.c1b9a40d.png";